export * from './lib/UiProductButtonSubscribe';

/* TODO: в этой задаче не хватило времени, но по хорошему надо выделить 1-2ч и создать компонент UiProductButtonBase
   который будет подключаться сюда и в UiProductButtonBuy
 */
